export default __webpack_public_path__ + "images/pin_b50f11.svg";